"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryConditionKind = exports.GENERAL_VALUE_SLICE_KEYS = exports.GENERAL_CONSOLIDATION_SLICE_KEYS = exports.FUNCTION_SIGNAL_MAPPING_SLICE_KEY = exports.FUNCTIONS_SLICE_KEY = exports.RESOURCES_SLICE_KEY = exports.DRIVE_MODES_SLICE_KEY = exports.OC_BOUNDARIES_SLICE_KEY = exports.AMR_BOUNDARIES_SLICE_KEY = exports.SIGNAL_TIES_SLICE_KEY = exports.FLOATING_BEHAVIOUR_SLICE_KEY = exports.PIN_ASSIGNMENTS_SLICE_KEY = exports.PINOUT_SLICE_KEY = exports.SIGNAL_ATTRIBUTES_SLICE_KEY = exports.MODES_SLICE_KEY = exports.SIGNAL_SET_SLICE_KEY = void 0;
exports.buildSignalSetRows = buildSignalSetRows;
exports.buildSignalAttributeRows = buildSignalAttributeRows;
exports.buildPinoutRows = buildPinoutRows;
exports.buildPinAssignmentRows = buildPinAssignmentRows;
exports.buildFloatingBehaviourRows = buildFloatingBehaviourRows;
exports.buildSignalTieRows = buildSignalTieRows;
exports.buildBoundaryConditionRows = buildBoundaryConditionRows;
exports.buildDriveModeRows = buildDriveModeRows;
exports.buildModeReferenceLabels = buildModeReferenceLabels;
exports.buildModeRows = buildModeRows;
exports.buildResourceRows = buildResourceRows;
exports.buildFunctionRows = buildFunctionRows;
exports.buildFunctionSignalMappingRows = buildFunctionSignalMappingRows;
exports.createGeneralReviewSlices = createGeneralReviewSlices;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const deepEqual = require("fast-deep-equal");
const boundary_conditions_denormalized_1 = require("../../DataScience/Types/boundary-conditions-denormalized");
const condition_mode_denormalized_1 = require("../../DataScience/Types/condition-mode-denormalized");
const component_function_denormalized_1 = require("../../DataScience/Types/component-function-denormalized");
const signal_attributes_denormalized_1 = require("../../DataScience/Types/signal-attributes-denormalized");
const signal_drive_characteristics_denormalized_1 = require("../../DataScience/Types/signal-drive-characteristics-denormalized");
const SignalTies_1 = require("../../SignalTies");
const signal_name_normalization_1 = require("../../DataScience/signal-hygiene/signal-name-normalization");
const si_comparison_1 = require("../../Comparison/si-comparison");
const comparison_spec_1 = require("../comparison-spec");
const consensus_assembler_1 = require("../consensus-assembler/consensus-assembler");
const multi_reviewer_consensus_service_1 = require("../multi-reviewer-consensus.service");
const boundary_conditions_comparison_1 = require("../comparisons/boundary-conditions.comparison");
const drive_modes_comparison_1 = require("../comparisons/drive-modes.comparison");
const floating_behaviour_comparison_1 = require("../comparisons/floating-behaviour.comparison");
const functions_comparison_1 = require("../comparisons/functions.comparison");
const function_signal_mapping_comparison_1 = require("../comparisons/function-signal-mapping.comparison");
const modes_comparison_1 = require("../comparisons/modes.comparison");
const pin_assignments_comparison_1 = require("../comparisons/pin-assignments.comparison");
const pinout_comparison_1 = require("../comparisons/pinout.comparison");
const resources_comparison_1 = require("../comparisons/resources.comparison");
const sigma_model_parameters_comparison_1 = require("../comparisons/sigma-model-parameters.comparison");
const scalar_comparison_1 = require("../comparisons/scalar.comparison");
const signal_attributes_comparison_1 = require("../comparisons/signal-attributes.comparison");
const signal_set_comparison_1 = require("../comparisons/signal-set.comparison");
const signal_ties_comparison_1 = require("../comparisons/signal-ties.comparison");
const slice_contracts_1 = require("../slice-contracts");
const slice_key_1 = require("../slice-key");
const slice_scoped_logger_1 = require("../slice-scoped-logger");
const condition_canonicalization_1 = require("./condition-canonicalization");
exports.SIGNAL_SET_SLICE_KEY = slice_key_1.SliceKey.SignalSet;
exports.MODES_SLICE_KEY = slice_key_1.SliceKey.Modes;
exports.SIGNAL_ATTRIBUTES_SLICE_KEY = slice_key_1.SliceKey.SignalAttributes;
exports.PINOUT_SLICE_KEY = slice_key_1.SliceKey.Pinout;
exports.PIN_ASSIGNMENTS_SLICE_KEY = slice_key_1.SliceKey.PinAssignments;
exports.FLOATING_BEHAVIOUR_SLICE_KEY = slice_key_1.SliceKey.FloatingBehaviour;
exports.SIGNAL_TIES_SLICE_KEY = slice_key_1.SliceKey.SignalTies;
exports.AMR_BOUNDARIES_SLICE_KEY = slice_key_1.SliceKey.AmrBoundaries;
exports.OC_BOUNDARIES_SLICE_KEY = slice_key_1.SliceKey.OcBoundaries;
exports.DRIVE_MODES_SLICE_KEY = slice_key_1.SliceKey.DriveModes;
exports.RESOURCES_SLICE_KEY = slice_key_1.SliceKey.Resources;
exports.FUNCTIONS_SLICE_KEY = slice_key_1.SliceKey.Functions;
exports.FUNCTION_SIGNAL_MAPPING_SLICE_KEY = slice_key_1.SliceKey.FunctionSignalMapping;
exports.GENERAL_CONSOLIDATION_SLICE_KEYS = [exports.SIGNAL_SET_SLICE_KEY, exports.MODES_SLICE_KEY];
exports.GENERAL_VALUE_SLICE_KEYS = [
    exports.SIGNAL_ATTRIBUTES_SLICE_KEY,
    exports.PINOUT_SLICE_KEY,
    exports.FLOATING_BEHAVIOUR_SLICE_KEY,
    exports.SIGNAL_TIES_SLICE_KEY,
    exports.AMR_BOUNDARIES_SLICE_KEY,
    exports.OC_BOUNDARIES_SLICE_KEY,
    exports.DRIVE_MODES_SLICE_KEY,
    exports.RESOURCES_SLICE_KEY,
    exports.FUNCTIONS_SLICE_KEY,
    exports.FUNCTION_SIGNAL_MAPPING_SLICE_KEY,
    slice_contracts_1.PARAMETERS_SLICE_KEY,
];
const projectionLogger = (0, sigma_engine_shared_1.generateCompatibleConsoleLogger)();
class GeneralReviewSlice {
    resolveSpec(_payloads) {
        return this.spec;
    }
    normalizeValue(column, value, row) {
        return this.resolveSpec([]).normalize(column, value, row);
    }
    admitsValue(column, value) {
        return this.resolveSpec([]).admitsValue(column, value);
    }
    rowKeyOf(row) {
        return this.resolveSpec([]).rowKeyOf(row);
    }
    rowCellsFromKey(rowKey) {
        return this.resolveSpec([]).rowCellsFromKey(rowKey);
    }
    withRows(table, rows) {
        const spec = this.resolveSpec([]);
        const existing = table === undefined ? [] : spec.toRows(table);
        const present = new Set(existing.map((row) => spec.rowKeyOf(row)));
        const added = rows.filter((row) => !present.has(spec.rowKeyOf(row)));
        return added.length === 0 ? table : spec.fromRows([...existing, ...added]);
    }
    run(submissions, policies, logger) {
        const scoped = new slice_scoped_logger_1.SliceScopedLogger(this.sliceKey, logger ?? projectionLogger);
        const service = new multi_reviewer_consensus_service_1.MultiReviewerConsensusService(scoped);
        const projected = submissions.map(([reviewerId, payload]) => [reviewerId, this.buildData(payload, scoped)]);
        const spec = this.resolveSpec(submissions.map(([, payload]) => payload));
        const membershipHoldings = spec.membershipScopeColumns === undefined ?
            undefined
            : new Map(submissions.map(([reviewerId, payload]) => [
                reviewerId,
                new Set(payload.signals.map((signal) => (0, signal_name_normalization_1.normalizeSignalNameForComparison)(signal.name))),
            ]));
        return service.run(projected, {
            spec,
            confidencePolicy: policies.confidencePolicy,
            triagePolicy: policies.triagePolicy,
            assembler: new consensus_assembler_1.ConsensusAssembler(),
            membershipHoldings,
        });
    }
    autoResolveColumnNames() {
        return [...this.spec.autoResolveColumns.keys()].map(String);
    }
    keyColumnNames() {
        const alignment = this.spec.alignment;
        return alignment instanceof comparison_spec_1.CellAlignment ? alignment.keyColumns.map(String) : [];
    }
    valueColumnNames() {
        const alignment = this.spec.alignment;
        return alignment instanceof comparison_spec_1.CellAlignment ? alignment.valueColumns.map(String) : [];
    }
}
function signalNameById(payload) {
    return new Map(payload.signals.map((signal) => [String(signal.id), signal.name]));
}
function buildSignalSetRows(payload) {
    return payload.signals.map((signal) => {
        const attributes = (0, signal_attributes_denormalized_1.getSignalAttributesInDenormalizedFormat)(signal);
        const flags = [
            attributes.direction ?? '',
            attributes.power ? 'power' : '',
            attributes.ground ? 'ground' : '',
            attributes.analog ? 'analog' : '',
            attributes.digital ? 'digital' : '',
            attributes.exposedPad ? 'exposed pad' : '',
            attributes.noConnect ? 'no connect' : '',
            attributes.activeLow ? 'active low' : '',
        ].filter((flag) => flag !== '');
        return {
            signalId: String(signal.id),
            signalName: signal.name,
            pins: [...(payload.pinout[String(signal.id)] ?? [])],
            attributes: flags.join(', '),
            description: attributes.description ?? '',
        };
    });
}
function buildSignalAttributeRows(payload) {
    return payload.signals.map((signal) => ({
        ...(0, signal_attributes_denormalized_1.getSignalAttributesInDenormalizedFormat)(signal),
        modelSignal: signal.modelSignal === undefined ? null : String(signal.modelSignal),
    }));
}
function buildPinoutRows(payload) {
    const nameById = signalNameById(payload);
    const pinsByName = new Map();
    for (const [signalId, pinIds] of Object.entries(payload.pinout)) {
        const signalName = nameById.get(signalId);
        if (signalName === undefined) {
            continue;
        }
        const list = pinsByName.get(signalName) ?? [];
        list.push(...pinIds);
        pinsByName.set(signalName, list);
    }
    return [...pinsByName.entries()].map(([signalName, pins]) => ({ signalName, pins: (0, pinout_comparison_1.joinPinList)(pins) }));
}
function buildPinAssignmentRows(payload) {
    const nameById = signalNameById(payload);
    const rows = [];
    for (const [signalId, pinIds] of Object.entries(payload.pinout)) {
        const signalName = nameById.get(signalId);
        if (signalName === undefined) {
            continue;
        }
        for (const pinId of pinIds) {
            rows.push({ pinId, signalName });
        }
    }
    return rows;
}
function buildFloatingBehaviourRows(payload) {
    return payload.signals.map((signal) => ({
        signalName: signal.name,
        floatingBehaviour: signal.floatingBehavior ?? '',
    }));
}
function buildSignalTieRows(payload, logger = projectionLogger) {
    const directionRule = new SignalTies_1.SignalTieDirectionRule(payload.signals.map(signal_attributes_denormalized_1.getSignalAttributesInDenormalizedFormat));
    const rows = [];
    for (const signal of payload.signals) {
        if (!signal.ties) {
            continue;
        }
        for (const externalComponent of signal.ties) {
            for (const single of (0, SignalTies_1.splitExternalComponentByConnection)(externalComponent)) {
                const flatTie = (0, SignalTies_1.convertExternalComponentToFlatSignalTie)(single, payload.signals, logger);
                if (flatTie === null) {
                    continue;
                }
                const toSignalName = sigma_engine_shared_1.DesignModels.findSignalNameBySignalId(flatTie.toSignalId, payload.signals, logger) ?? flatTie.toSignalId;
                const values = (0, SignalTies_1.flatTieToRowValues)(flatTie);
                rows.push(directionRule.orientEnds({
                    signalName: signal.name,
                    toSignalName,
                    connectionType: flatTie.connectionType,
                    componentType: values.componentType,
                    componentValueAbs: values.componentValueAbs,
                    componentValueMin: values.componentValueMin,
                    componentValueMax: values.componentValueMax,
                    componentValueVariance: values.componentValueVariance,
                    polarity: values.polarity,
                }));
            }
        }
    }
    return rows;
}
var BoundaryConditionKind;
(function (BoundaryConditionKind) {
    BoundaryConditionKind["Amr"] = "amr";
    BoundaryConditionKind["Oc"] = "oc";
})(BoundaryConditionKind || (exports.BoundaryConditionKind = BoundaryConditionKind = {}));
const BOUND_MERGE_RULES = [
    { column: 'minimum', keep: 'highest' },
    { column: 'nominal', keep: 'lowest' },
    { column: 'maximum', keep: 'lowest' },
];
function numericBound(value, characteristic) {
    const parsed = Number((0, si_comparison_1.formatSIValue)(value, characteristic));
    return Number.isFinite(parsed) ? parsed : null;
}
function resolveConflictingBound(existing, incoming, characteristic, keep) {
    const existingMagnitude = numericBound(existing, characteristic);
    const incomingMagnitude = numericBound(incoming, characteristic);
    if (existingMagnitude === null || incomingMagnitude === null) {
        const existingWins = existing <= incoming;
        return {
            kept: existingWins ? existing : incoming,
            discarded: existingWins ? incoming : existing,
            rule: 'lexicographic',
        };
    }
    const existingWins = keep === 'highest' ? existingMagnitude >= incomingMagnitude : existingMagnitude <= incomingMagnitude;
    return { kept: existingWins ? existing : incoming, discarded: existingWins ? incoming : existing, rule: keep };
}
function mergeBoundaryRows(existing, incoming, spec, logger) {
    const merged = { ...existing };
    for (const { column, keep } of BOUND_MERGE_RULES) {
        const candidate = incoming[column];
        if (candidate === null) {
            continue;
        }
        const held = merged[column];
        if (held === null) {
            merged[column] = candidate;
            continue;
        }
        if (spec.normalize(column, held, merged) === spec.normalize(column, candidate, incoming)) {
            continue;
        }
        const resolution = resolveConflictingBound(held, candidate, incoming.characteristic, keep);
        logger.warn('BuildBoundaryConditionRows_ConflictingBound', {
            signalName: incoming.signalName,
            relativeToSignalName: incoming.relativeToSignalName,
            characteristic: incoming.characteristic,
            conditions: incoming.conditions,
            column,
            kept: resolution.kept,
            discarded: resolution.discarded,
            rule: resolution.rule,
        });
        merged[column] = resolution.kept;
    }
    return merged;
}
function unionRowsByKey(rows, spec, logger) {
    const byKey = new Map();
    for (const row of rows) {
        const key = spec.rowKeyOf(row);
        const existing = byKey.get(key);
        byKey.set(key, existing === undefined ? row : mergeBoundaryRows(existing, row, spec, logger));
    }
    return [...byKey.values()];
}
function declaredRelativeSignalIds(boundary) {
    const relativeTo = boundary.boundary.relative_to;
    if (relativeTo === undefined) {
        return [];
    }
    const entries = Array.isArray(relativeTo) ? relativeTo : [relativeTo];
    return entries.flatMap((entry) => (entry.signal === undefined ? [] : [String(entry.signal)]));
}
function collapseRelativeSignalName(entry, logger) {
    const references = [
        entry.minimumRelativeToSignalName,
        entry.nominalRelativeToSignalName,
        entry.maximumRelativeToSignalName,
    ].filter((reference) => reference !== null && reference !== undefined && reference !== '');
    const distinct = [...new Set(references)];
    if (distinct.length > 1) {
        logger.warn('BuildBoundaryConditionRows_DivergentRelativeSignals', {
            signalName: entry.signalName,
            characteristic: entry.characteristic,
            references: distinct,
        });
    }
    return references[0] ?? '';
}
function buildBoundaryConditionRows(payload, kind, logger = (0, sigma_engine_shared_1.generateCompatibleConsoleLogger)()) {
    const rows = [];
    for (const boundary of payload.boundaries) {
        const denormalized = kind === BoundaryConditionKind.Amr ?
            (0, boundary_conditions_denormalized_1.convertBoundariesToAmrDenormalized)([boundary], payload.signals).map((entry) => ({
                ...entry,
                nominal: null,
                nominalRelativeToSignalName: null,
            }))
            : (0, boundary_conditions_denormalized_1.convertBoundariesToOcDenormalized)([boundary], payload.signals);
        if (denormalized.length === 0) {
            continue;
        }
        const conditions = (0, condition_canonicalization_1.canonicalizeModeConditions)(boundary.conditions, payload.modes, payload.signals, logger);
        const declaresReference = declaredRelativeSignalIds(boundary).length > 0;
        for (const entry of denormalized) {
            const relativeToSignalName = collapseRelativeSignalName(entry, logger);
            if (declaresReference && relativeToSignalName === '') {
                logger.warn('BuildBoundaryConditionRows_UnresolvedRelativeSignal', {
                    signalName: entry.signalName,
                    characteristic: entry.characteristic,
                    declaredRelativeSignalIds: declaredRelativeSignalIds(boundary),
                });
            }
            rows.push({
                signalName: entry.signalName,
                relativeToSignalName,
                characteristic: entry.characteristic,
                conditions,
                minimum: entry.minimum ?? null,
                nominal: entry.nominal ?? null,
                maximum: entry.maximum ?? null,
                ...(boundary.conditions === undefined ? {} : { sourceConditions: boundary.conditions }),
            });
        }
    }
    return unionRowsByKey(rows, new boundary_conditions_comparison_1.BoundaryConditionsComparison(), logger);
}
function driveModeModeConditions(driveMode, signalName, logger) {
    const conditions = [];
    for (const entry of driveMode.conditions ?? []) {
        const condition = entry.condition;
        if ((0, sigma_engine_shared_1.isModeReferenceCondition)(condition) ||
            (0, sigma_engine_shared_1.isModeSignalLogicalStateCondition)(condition) ||
            'boundary' in condition) {
            conditions.push(condition);
            continue;
        }
        logger.warn('BuildDriveModeRows_NonModeConditionExcluded', {
            signalName,
            driveModeType: driveMode.type,
            conditionKeys: Object.keys(condition),
        });
    }
    return conditions;
}
function mergeDriveModeRows(existing, incoming, spec, logger) {
    const merged = { ...existing };
    for (const column of drive_modes_comparison_1.DRIVE_MODE_VALUE_COLUMNS) {
        const candidate = incoming[column];
        if (candidate === null || candidate === undefined) {
            continue;
        }
        const held = merged[column];
        if (held === null || held === undefined) {
            merged[column] = candidate;
            continue;
        }
        if (spec.normalize(column, held, merged) === spec.normalize(column, candidate, incoming)) {
            continue;
        }
        logger.warn('BuildDriveModeRows_ConflictingValue', {
            signalName: incoming.signalName,
            inputType: incoming.inputType,
            outputType: incoming.outputType,
            conditionId: incoming.conditionId,
            column,
            kept: held,
            discarded: candidate,
        });
    }
    if (!deepEqual(existing.sourceConditions, incoming.sourceConditions)) {
        logger.warn('BuildDriveModeRows_DivergentSourceConditions', {
            signalName: incoming.signalName,
            inputType: incoming.inputType,
            outputType: incoming.outputType,
            conditionId: incoming.conditionId,
        });
    }
    return merged;
}
function unionDriveModeRowsByKey(rows, spec, logger) {
    const byKey = new Map();
    for (const row of rows) {
        const key = spec.rowKeyOf(row);
        const existing = byKey.get(key);
        byKey.set(key, existing === undefined ? row : mergeDriveModeRows(existing, row, spec, logger));
    }
    return [...byKey.values()];
}
function buildDriveModeRows(payload, logger = (0, sigma_engine_shared_1.generateCompatibleConsoleLogger)()) {
    const spec = new drive_modes_comparison_1.DriveModesComparison();
    const nulledNeverReviewedColumns = Object.fromEntries(drive_modes_comparison_1.NEVER_REVIEWED_DRIVE_MODE_COLUMNS.map((column) => [column, null]));
    const sourceRows = payload.signals.flatMap((signal) => (signal.supportedDriveModes ?? []).map((driveMode) => {
        const row = (0, signal_drive_characteristics_denormalized_1.convertSignalDriveModeToSignalDriveCharacteristicsDenormalized)(driveMode, signal.name);
        const conditions = driveModeModeConditions(driveMode, signal.name, logger);
        return {
            ...row,
            ...nulledNeverReviewedColumns,
            conditionId: (0, condition_canonicalization_1.canonicalizeModeConditions)(conditions, payload.modes, payload.signals, logger),
            ...(driveMode.conditions === undefined ? {} : { sourceConditions: driveMode.conditions }),
        };
    }));
    return spec.fromRows(unionDriveModeRowsByKey(spec.toRows(sourceRows), spec, logger));
}
function buildModeReferenceLabels(payload) {
    const nameById = signalNameById(payload);
    const labels = new Map();
    const add = (modeId, label) => {
        const list = labels.get(modeId) ?? [];
        if (!list.includes(label)) {
            list.push(label);
            labels.set(modeId, list);
        }
    };
    for (const boundary of payload.boundaries) {
        const kind = boundary.boundary.class === sigma_engine_shared_1.BoundaryClass.IC_AbsoluteMaximumRating ? 'AMR' : 'OC';
        const targetNames = (0, sigma_engine_shared_1.getBoundaryTargetSignalIds)(payload.signals, boundary.boundary.target)
            .map((id) => nameById.get(String(id)) ?? String(id))
            .join('/');
        for (const condition of boundary.conditions ?? []) {
            if ((0, sigma_engine_shared_1.isModeReferenceCondition)(condition)) {
                add(condition.mode, `${kind}: ${targetNames}`);
            }
        }
    }
    for (const signal of payload.signals) {
        for (const driveMode of signal.supportedDriveModes ?? []) {
            for (const driveCondition of driveMode.conditions ?? []) {
                const condition = driveCondition.condition;
                if (condition !== null && typeof condition === 'object' && (0, sigma_engine_shared_1.isModeReferenceCondition)(condition)) {
                    add(condition.mode, `drive mode: ${signal.name}`);
                }
            }
        }
    }
    for (const resource of payload.resources) {
        for (const condition of resource.conditions ?? []) {
            if ((0, sigma_engine_shared_1.isModeReferenceCondition)(condition)) {
                add(condition.mode, `resource: ${resource.name}`);
            }
        }
    }
    return labels;
}
function buildModeRows(payload, logger = projectionLogger) {
    const referenceLabels = buildModeReferenceLabels(payload);
    return payload.modes.flatMap((mode) => {
        try {
            const denormalized = (0, condition_mode_denormalized_1.convertModeBaseToConditionModeDenormalized)(mode, payload.signals);
            return (0, condition_mode_denormalized_1.convertConditionModeSignalsFromIdsToNames)(denormalized, payload.signals, logger).map((entry) => ({
                id: mode.id,
                characteristic: entry.characteristic,
                minVal: entry.minVal,
                nominalVal: entry.nominalVal,
                maxVal: entry.maxVal,
                targetSignal: entry.targetSignal,
                relativeSignal: entry.relativeSignal,
                referencedBy: (referenceLabels.get(mode.id) ?? []).join('; '),
            }));
        }
        catch {
            logger.warn('BuildModeRows_UnflattenableMode', { modeId: mode.id });
            return [];
        }
    });
}
function buildResourceRows(payload, logger = projectionLogger) {
    return payload.resources.map((resource) => ({
        name: resource.name,
        mustBeConsumed: resource.mustBeConsumed ?? false,
        conditions: (0, condition_canonicalization_1.canonicalizeModeConditions)(resource.conditions, payload.modes, payload.signals, logger),
        ...(resource.conditions === undefined ? {} : { sourceConditions: resource.conditions }),
    }));
}
function buildFunctionRows(payload) {
    return payload.functions.map((componentFunction) => {
        const denormalized = (0, component_function_denormalized_1.convertIComponentFunctionToComponentFunctionDenormalized)(componentFunction, payload.signals);
        return {
            name: denormalized.name,
            functionClass: denormalized.functionClass ?? '',
            busRole: denormalized.busRole ?? '',
            mustBeAssigned: denormalized.mustBeAssigned,
            resourceConsumed: denormalized.resourceConsumed ?? '',
            functionSignals: denormalized.functionSignals,
        };
    });
}
function buildFunctionSignalMappingRows(payload) {
    return payload.functions.flatMap((componentFunction) => {
        const denormalized = (0, component_function_denormalized_1.convertIComponentFunctionToComponentFunctionDenormalized)(componentFunction, payload.signals);
        return denormalized.functionSignals
            .filter((functionSignal) => functionSignal.signalNames.length > 0)
            .map((functionSignal) => ({
            functionName: denormalized.name,
            functionSignalName: functionSignal.name,
            signalNames: functionSignal.signalNames,
        }));
    });
}
function anyArrayPayload(payloads) {
    return payloads.some((payload) => (0, slice_contracts_1.readElementSigmaModelType)(payload) !== '');
}
class GeneralSigmaModelTypeSlice extends GeneralReviewSlice {
    constructor() {
        super(...arguments);
        this.sliceKey = slice_contracts_1.SIGMA_MODEL_TYPE_SLICE_KEY;
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.None;
        this.spec = new scalar_comparison_1.ScalarComparison(slice_contracts_1.SIGMA_MODEL_TYPE_SLICE_KEY);
    }
    appliesTo() {
        return true;
    }
    buildData(payload) {
        return payload.sigmaModelType;
    }
}
class GeneralElementSigmaModelTypeSlice extends GeneralReviewSlice {
    constructor() {
        super(...arguments);
        this.sliceKey = slice_contracts_1.ELEMENT_SIGMA_MODEL_TYPE_SLICE_KEY;
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.ModelType;
        this.spec = new scalar_comparison_1.ScalarComparison(slice_contracts_1.ELEMENT_SIGMA_MODEL_TYPE_SLICE_KEY);
    }
    appliesTo(payloads) {
        return anyArrayPayload(payloads);
    }
    buildData(payload) {
        return (0, slice_contracts_1.readElementSigmaModelType)(payload);
    }
}
class SignalSetSlice extends GeneralReviewSlice {
    constructor() {
        super(...arguments);
        this.sliceKey = exports.SIGNAL_SET_SLICE_KEY;
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.None;
        this.spec = new signal_set_comparison_1.SignalSetComparison();
    }
    appliesTo(payloads) {
        return payloads.some((payload) => payload.signals.length > 0);
    }
    buildData(payload) {
        return buildSignalSetRows(payload);
    }
}
class ModesSlice extends GeneralReviewSlice {
    constructor() {
        super(...arguments);
        this.sliceKey = exports.MODES_SLICE_KEY;
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.None;
        this.spec = new modes_comparison_1.ModesComparison();
    }
    appliesTo(payloads) {
        return payloads.some((payload) => payload.modes.length > 0);
    }
    buildData(payload, logger) {
        return buildModeRows(payload, logger);
    }
}
class SignalAttributesSlice extends GeneralReviewSlice {
    constructor() {
        super(...arguments);
        this.sliceKey = exports.SIGNAL_ATTRIBUTES_SLICE_KEY;
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.None;
        this.spec = new signal_attributes_comparison_1.SignalAttributesComparison();
    }
    appliesTo(payloads) {
        return payloads.some((payload) => payload.signals.length > 0);
    }
    buildData(payload) {
        return buildSignalAttributeRows(payload);
    }
}
class PinoutSlice extends GeneralReviewSlice {
    constructor() {
        super(...arguments);
        this.sliceKey = exports.PINOUT_SLICE_KEY;
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.None;
        this.spec = new pinout_comparison_1.PinoutComparison();
    }
    appliesTo(payloads) {
        return payloads.some((payload) => Object.keys(payload.pinout).length > 0);
    }
    buildData(payload) {
        return buildPinoutRows(payload);
    }
}
class PinAssignmentsSlice extends GeneralReviewSlice {
    constructor() {
        super(...arguments);
        this.sliceKey = exports.PIN_ASSIGNMENTS_SLICE_KEY;
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.None;
        this.spec = new pin_assignments_comparison_1.PinAssignmentsComparison();
    }
    appliesTo(payloads) {
        return payloads.some((payload) => Object.keys(payload.pinout).length > 0);
    }
    buildData(payload) {
        return buildPinAssignmentRows(payload);
    }
}
class FloatingBehaviourSlice extends GeneralReviewSlice {
    constructor() {
        super(...arguments);
        this.sliceKey = exports.FLOATING_BEHAVIOUR_SLICE_KEY;
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.None;
        this.spec = new floating_behaviour_comparison_1.FloatingBehaviourComparison();
    }
    appliesTo(payloads) {
        return payloads.some((payload) => payload.signals.some((signal) => signal.floatingBehavior !== undefined));
    }
    buildData(payload) {
        return buildFloatingBehaviourRows(payload);
    }
}
class SignalTiesSlice extends GeneralReviewSlice {
    constructor() {
        super(...arguments);
        this.sliceKey = exports.SIGNAL_TIES_SLICE_KEY;
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.None;
        this.spec = new signal_ties_comparison_1.SignalTiesComparison();
    }
    appliesTo(payloads) {
        return payloads.some((payload) => payload.signals.some((signal) => (signal.ties ?? []).length > 0));
    }
    buildData(payload, logger) {
        return buildSignalTieRows(payload, logger);
    }
}
class SilentLogger {
    info() { }
    warn() { }
    error() { }
}
const APPLICABILITY_PROBE_LOGGER = new SilentLogger();
class BoundaryConditionsSlice extends GeneralReviewSlice {
    constructor(sliceKey, kind) {
        super();
        this.sliceKey = sliceKey;
        this.kind = kind;
        this.spec = new boundary_conditions_comparison_1.BoundaryConditionsComparison();
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.None;
    }
    appliesTo(payloads) {
        return payloads.some((payload) => this.buildData(payload, APPLICABILITY_PROBE_LOGGER).length > 0);
    }
    buildData(payload, logger) {
        return buildBoundaryConditionRows(payload, this.kind, logger);
    }
}
class DriveModesSlice extends GeneralReviewSlice {
    constructor() {
        super(...arguments);
        this.sliceKey = exports.DRIVE_MODES_SLICE_KEY;
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.None;
        this.spec = new drive_modes_comparison_1.DriveModesComparison();
    }
    appliesTo(payloads) {
        return payloads.some((payload) => payload.signals.some((signal) => (signal.supportedDriveModes ?? []).length > 0));
    }
    buildData(payload, logger) {
        return buildDriveModeRows(payload, logger);
    }
}
class ResourcesSlice extends GeneralReviewSlice {
    constructor() {
        super(...arguments);
        this.sliceKey = exports.RESOURCES_SLICE_KEY;
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.None;
        this.spec = new resources_comparison_1.ResourcesComparison();
    }
    appliesTo(payloads) {
        return payloads.some((payload) => payload.resources.length > 0);
    }
    buildData(payload, logger) {
        return buildResourceRows(payload, logger);
    }
}
class FunctionsSlice extends GeneralReviewSlice {
    constructor() {
        super(...arguments);
        this.sliceKey = exports.FUNCTIONS_SLICE_KEY;
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.None;
        this.spec = new functions_comparison_1.FunctionsComparison();
    }
    appliesTo(payloads) {
        return payloads.some((payload) => payload.functions.length > 0);
    }
    buildData(payload) {
        return buildFunctionRows(payload);
    }
}
class FunctionSignalMappingSlice extends GeneralReviewSlice {
    constructor() {
        super(...arguments);
        this.sliceKey = exports.FUNCTION_SIGNAL_MAPPING_SLICE_KEY;
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.None;
        this.spec = new function_signal_mapping_comparison_1.FunctionSignalMappingComparison();
    }
    appliesTo(payloads) {
        return payloads.some((payload) => buildFunctionSignalMappingRows(payload).length > 0);
    }
    buildData(payload) {
        return buildFunctionSignalMappingRows(payload);
    }
}
class GeneralParametersSlice extends GeneralReviewSlice {
    constructor(paramUnitsResolver, sigmaModelType) {
        super();
        this.paramUnitsResolver = paramUnitsResolver;
        this.sliceKey = slice_contracts_1.PARAMETERS_SLICE_KEY;
        this.maskPolicy = slice_contracts_1.SliceMaskPolicy.ModelType;
        this.spec = new sigma_model_parameters_comparison_1.SigmaModelParametersComparison();
        this.stampedSpec = this.specFor(sigmaModelType);
    }
    appliesTo(payloads) {
        return payloads.some((payload) => Object.keys(payload.parameters).length > 0);
    }
    buildData(payload) {
        return payload.parameters;
    }
    resolveSpec(payloads) {
        const modelType = payloads[0]?.sigmaModelType;
        return modelType === undefined ? this.stampedSpec : this.specFor(modelType);
    }
    specFor(sigmaModelType) {
        if (this.paramUnitsResolver === undefined || sigmaModelType === undefined || sigmaModelType.length === 0) {
            return new sigma_model_parameters_comparison_1.SigmaModelParametersComparison();
        }
        return new sigma_model_parameters_comparison_1.SigmaModelParametersComparison({}, this.paramUnitsResolver(sigmaModelType));
    }
}
function createGeneralReviewSlices(paramUnitsResolver, options) {
    return [
        new GeneralSigmaModelTypeSlice(),
        new GeneralElementSigmaModelTypeSlice(),
        new SignalSetSlice(),
        ...(options?.includeModesSlice === true ? [new ModesSlice()] : []),
        new SignalAttributesSlice(),
        new PinoutSlice(),
        new FloatingBehaviourSlice(),
        new SignalTiesSlice(),
        new BoundaryConditionsSlice(exports.AMR_BOUNDARIES_SLICE_KEY, BoundaryConditionKind.Amr),
        new BoundaryConditionsSlice(exports.OC_BOUNDARIES_SLICE_KEY, BoundaryConditionKind.Oc),
        new DriveModesSlice(),
        new ResourcesSlice(),
        new FunctionsSlice(),
        new FunctionSignalMappingSlice(),
        new GeneralParametersSlice(paramUnitsResolver, options?.sigmaModelType),
        ...(options?.includePinAssignmentsSlice === true ? [new PinAssignmentsSlice()] : []),
    ];
}
//# sourceMappingURL=general-package-slices.js.map